export const environment = {
    production: false,
    apiEndpoint: 'https://time-management-api.mcd-qa.net/api/v1',
    stsAuthority: 'https://portal.mcd-qa.net/Identity/',
    clientId: 'TimeManagement',
    clientRoot: 'https://cunds-timemanagement-ui-qa.azurewebsites.net/',
    clientScope: 'openid profile email rights customerIdentifier',
    clientSecret: 'F621F470-9731-4A25-80EF-67A6F7C5F4B8'
};
